import { withSvgIcon } from './withSvgIcon';

export const SystemIcon = withSvgIcon(
  <>
    <path
      d="M2.5 5C2.5 4.05719 2.5 3.58579 2.79289 3.29289C3.08579 3 3.55719 3 4.5 3H15.5C16.4428 3 16.9142 3 17.2071 3.29289C17.5 3.58579 17.5 4.05719 17.5 5V12C17.5 12.9428 17.5 13.4142 17.2071 13.7071C16.9142 14 16.4428 14 15.5 14H4.5C3.55719 14 3.08579 14 2.79289 13.7071C2.5 13.4142 2.5 12.9428 2.5 12V5Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M8 17H12"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
  </>,
  { viewBox: '0 0 20 20' },
);
